import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { type ExperienceMultiSurveyCardCompetitionSection } from '@bbkAdminRedux/rtkq/experience.slice';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { FunnelInput } from '@bbkFunnel/components/v2';

export type CompetitorOtherTextHandler = (
  val: string,
  opts: { type: 'track' | 'change' }
) => void;

type Props = {
  question: ExperienceMultiSurveyCardCompetitionSection;
  showOther: boolean;
  compOtherText: string;
  handleOtherText: CompetitorOtherTextHandler;
};
export const CompetitionOtherText: ReactFCC<Props> = (props) => {
  const otherInputRef = useRef<HTMLInputElement>(null);
  const { question, showOther, compOtherText, handleOtherText } = props;

  useEffect(() => {
    otherInputRef.current?.focus();
  }, [showOther]);

  const placeholder = _.get(
    question,
    'otherTextPlaceholder',
    _.get(question, 'placeholder', 'Start typing...')
  );

  return (
    <div>
      {showOther && (
        <div className="comp-other-text" css={{ marginTop: 10 }}>
          <FunnelInput
            ref={otherInputRef}
            placeholder={placeholder}
            name="competitionOtherText"
            value={compOtherText}
            onChange={({ target: { value } }) => {
              handleOtherText(value, { type: 'change' });
            }}
            onBlur={({ target: { value } }) =>
              handleOtherText(value, { type: 'track' })
            }
            maxLength={140}
          />
        </div>
      )}
    </div>
  );
};
